export default "__VITE_ASSET__e5OHXRu2__"